import React from "react";
import { imageBasePath } from "../../Utils/config";
import "./style.css";
// import './demo.css'

const Stepper = ({
  steps,
  activeStep,
  subActiveStep,
  setActiveStep,
  setSubActiveStep,
}) => {
  return (
    <div>
      {steps?.map((step, index) => (
        <div
          key={index + 7}
          className={index === activeStep ? "step step-active" : "step"}
        >
          <div>
            <div
              className={`${
                activeStep === 2
                  ? `${
                      index < activeStep ? "circle-yellow" : "circle3"
                    } cursor-pointer`
                  : `${
                      index < activeStep ? "circle-yellow" : "circle"
                    } cursor-pointer`
              }`}
              onClick={() => setActiveStep(index)}
            >
              {index < activeStep ? (
                <img src={imageBasePath + "check.png"} alt="activeCheck" />
              ) : (
                index + 1
              )}
            </div>
          </div>
          <div>
            <div
              className="title cursor-pointer w-[240px] text-ellipsis overflow-hidden"
              onClick={() => setActiveStep(index)}
            >
              {step?.stepName}
            </div>
            {!!step?.subSteps?.length &&
              activeStep === 2 &&
              step?.subSteps?.map((subStep, subIndex) => (
                <div
                  key={subIndex + 5}
                  className="flex items-center mt-4 cursor-pointer w-[320px] overflow-hidden sm:overflow-visible"
                  onClick={() => setSubActiveStep(subIndex)}
                >
                  <div
                    className={`w-[24px] h-0 border-dashed border-${
                      subIndex === subActiveStep && activeStep === 2
                        ? "dottedDark"
                        : "dottedLight"
                    } border mr-2`}
                  ></div>
                  <div
                    className={`caption-${
                      subIndex === subActiveStep && activeStep === 2
                        ? "active"
                        : "inactive"
                    } w-[196px]`}
                  >
                    {subStep?.subStepName}
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
